module.exports = __webpack_public_path__ + "img/p113.9c50e335.jpg";